/* The app's one tab underline: the ember rule under the chosen tab and the way it moves.
 * A stylesheet with no component — every surface renders one empty `<i aria-hidden>`:
 *
 *     <i className={`${rule.rule} ${own.ruleBox} ${selected ? rule.ruleOn : ''}`} aria-hidden />
 *
 * Nothing may be declared on both sides (chunk order differs between dev and build — see
 * `emberButton.module.css`). The surface declares only `bottom` (where the rule meets its own bar's
 * hairline) and, where the canon draws one, `border-radius`. The chosen state is a second class on
 * the same element, so this module never depends on a class name it does not own.
 *
 * A CSS transition, not Motion: `tokens/base.css` collapses `transition-duration` under
 * `prefers-reduced-motion` and does not reach a Motion animation. `--ease` is the owner's choice
 * (18 Sep 2026) over `--ease-screen-entrance`. */

.rule {
  position: absolute;
  right: 0;
  left: 0;
  height: var(--border-tab);
  background: var(--primary-rule);
  transform: scaleX(0);
  transition: transform var(--dur-base) var(--ease);
}

/* After `.rule`, so the pair is decided by source order in ONE file. */
.ruleOn {
  transform: scaleX(1);
}
